import { css } from 'styled-components';
import makeThemedComponent from '../../utils/makeThemedComponent';
var defaultStyles = css(["background:#fff;border-color:#000;border-width:3px;border-style:solid;border-radius:0px;color:#000;cursor:pointer;font-family:inherit;font-weight:400;outline:none;padding:1rem;width:auto;"]);
/**
 * Renders a `button` element with some default styles.
 *
 * @public
 * @author Connor Taylor
 */

var Button = makeThemedComponent({
  themeKey: "Button",
  component: "button",
  defaultStyles: defaultStyles
});
export { defaultStyles };
/** @component */

export default Button;